module.exports = __webpack_public_path__ + "617d665663abc714d8bdf16978a90b9d.png";